import {
  combineGroupedPayments,
  groupByWeekWithoutCrossingMonths,
} from "../helpers";
import { fintechFunction } from "./fintechFunction";
import Decimal from "decimal.js";
import {
  getColumnData,
  create_unique_key,
  setHeaderToOutputColumns,
  getKeyByValue,
  insertDateRange,
} from "../utils";
export const execute_groupBy = (
  rule,
  worksheet,
  outputSheet,
  inputColumns,
  outputColumns,
) => {
  let groupedData = {};

  const groupByColumns = rule.grpByCol.map((col) =>
    getColumnData(worksheet, col),
  );
  const aggregateData = getColumnData(worksheet, rule.aggregateColumn);
  const rowCount = groupByColumns[0].length;
  // store positive and negative values separately (used in fintech)
  if (!rule?.positiveNegativeSeparately) {
    for (let i = 0; i < rowCount; i++) {
      let key = create_unique_key(rule, groupByColumns, i, inputColumns);
      if (!groupedData[key]) {
        groupedData[key] = rule.grpByCol.reduce((acc, col, index) => {
          acc[col] = groupByColumns[index][i]; // Set default value for each key
          return acc;
        }, {});

        groupedData[key][rule.aggregateColumn] = 0; // The culprit
      }

      groupedData[key][rule.aggregateColumn] = new Decimal(
        groupedData[key][rule.aggregateColumn] || 0,
      )
        .plus(new Decimal(aggregateData[i] || 0))
        .toNumber();
    }
  } else {
    // Combine data from grouping columns and amounts
    for (let i = 0; i < rowCount; i++) {
      let key = create_unique_key(rule, groupByColumns, i, inputColumns);

      // Initialize object if key doesn't exist
      if (!groupedData[key]) {
        groupedData[key] = rule.grpByCol.reduce((acc, col, index) => {
          acc[col] = groupByColumns[index][i]; // Set default values
          return acc;
        }, {});

        // Initialize separate positive & negative accumulations
        groupedData[key].positiveSum = 0;
        groupedData[key].negativeSum = 0;
      }

      // Convert aggregate column value to a number

      let value = new Decimal(aggregateData[i]);

      // Accumulate positive and negative values separately using Decimal
      if (value.greaterThanOrEqualTo(0)) {
        groupedData[key].positiveSum = new Decimal(groupedData[key].positiveSum)
          .plus(value)
          .toNumber();
      } else {
        groupedData[key].negativeSum = new Decimal(groupedData[key].negativeSum)
          .plus(value)
          .toNumber();
      }
    }
  }

  if (rule.dateColumnType === "week") {
    groupedData = groupByWeekWithoutCrossingMonths(
      groupedData,
      rule,
      inputColumns,
    );
  }
  outputSheet = setHeaderToOutputColumns(
    outputSheet,
    outputColumns,
    rule.outputTargetCol,
  );

  let currentRow = 2;

  // sum of grouped data based on combinations
  let updatedData = groupedData;
  if (Object.keys(rule?.customGrouping || []).length > 0) {
    updatedData = combineGroupedPayments(
      groupedData,
      rule.customGrouping,
      rule,
    ); // for example combine Visa, Master to Visa/Master, use in atlas and Lazada
  }
  // Group records together based on the second part of the key, used in "Lazada" to show  weekly records together
  if (rule.groupValuesByKey) {
    const groupedMap = new Map();
    // Group data by the second part of the key
    Object.entries(updatedData).forEach(([key, value]) => {
      const [, category] = key.split("*"); // Extract second part
      if (!groupedMap.has(category)) {
        groupedMap.set(category, []);
      }
      groupedMap.get(category)?.push({ key, value });
    });

    const sortedData = new Map();
    // Create a new object with sorted arrangement
    Array.from(groupedMap.entries()).forEach(([, entries]) => {
      entries.forEach(({ key, value }) => {
        sortedData[key] = value; // Insert into new object
      });
    });
    updatedData = sortedData;
  }
  // Incase of Fin-tech
  if (rule.activeTab === "2") {
    fintechFunction(rule, updatedData);
  } else {
    Object.values(updatedData).forEach((dataRow) => {
      Object.keys(dataRow).forEach((dataKey) => {
        let res = getKeyByValue(rule.grpByColMappings, dataKey);
        // use if res is not undefined  then only update outputSheet
        if (res !== undefined) {
          if (rule.dateColumnType === "week" && dataKey === rule.dateColumn) {
            outputSheet.getCell(`${res}${currentRow}`).value = insertDateRange(
              rule,
              dataRow,
              dataKey,
            );
          } else {
            outputSheet.getCell(`${res}${currentRow}`).value = String(
              dataRow[dataKey] || "",
            );
          }
        }
      });
      currentRow++;
    });
  }
  console.log(updatedData);
  return {
    data: updatedData,
  };
};
